import React from "react";

export const Block: React.FC<React.SVGAttributes<SVGSVGElement>> = ({
  stroke = "currentColor",
  fill = "currentColor",
  ...svgProps
}) => {
  return (
    <svg
      height="1em"
      width="1em"
      fill="none"
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
      {...svgProps}
    >
      <circle cx="16" cy="15.9999" r="10.1667" stroke={stroke} />
      <line
        stroke={stroke}
        x1="23.0203"
        x2="8.35364"
        y1="8.35355"
        y2="23.0202"
      />
    </svg>
  );
};
